import { useBaseAppVersionId } from "../../navigation/baseApps";
import { baseAppVersionsApi } from "../../services/api/baseAppVersions";
import FileListTabPage from "../files/FileListTabPage";

export default function BaseAppVersionFilesTabPage() {
    return <FileListTabPage api={baseAppVersionsApi.files} ownerId={useBaseAppVersionId()} />;
}
